<script lang="ts" setup>
import type { StrapiLocale } from '@nuxtjs/strapi/dist/runtime'
import PostComponent from '@ui/composites/PostComponent/PostComponent.vue'
import type { StrapiBlog } from '~~/types/strapi'
const { t, locale } = useI18n()

const {
  public: { siteUrl },
} = useRuntimeConfig()

useSeoMeta({
  title: t('blog-and-news'),
  description: t('stay-abreast-with'),
  ogTitle: t('blog-and-news'),
  ogDescription: t('stay-abreast-with'),
  ogImage: `${siteUrl}/images/blog/bg.webp`,
  ogImageWidth: '1200',
  ogImageHeight: '630',
  ogType: 'website',

  twitterTitle: t('blog-and-news'),
  twitterDescription: t('stay-abreast-with'),
  twitterImage: `${siteUrl}/images/blog/bg.webp`,
  twitterCard: 'summary_large_image',
})

definePageMeta({
  key: (route) => route.fullPath,
  layout: 'menu',
})

const route = useRoute()
const { find } = useStrapi()

const queryData = computed(() => ({
  locale: locale.value as StrapiLocale,
}))

const localeRoute = useLocaleRoute()

const { data: pageData } = await useAsyncData(
  `blog:${locale.value}`,
  () =>
    find<StrapiBlog>(`blogs`, {
      locale: queryData.value.locale,
      sort: ['date:desc', 'publishedAt:desc', 'updatedAt:desc'],
      pagination: {
        page: 1,
        pageSize: 100,
      },
      populate: ['image'],
    }),
  {
    watch: [queryData],
    immediate: true,
  }
)
</script>

<template>
  <div>
    <div class="flex flex-col relative h-91.75">
      <h1 class="pt-40.5 text-center tracking-wide text-[1.75rem]">
        {{ t('blog') }}
      </h1>
      <img
        alt="Blog"
        class="absolute top-0 left-0 right-0 h-91.75 w-full object-cover -z-1"
        src="/images/blog/bg.webp"
      />
    </div>
    <div class="mt-10">
      <div
        v-if="pageData?.data?.length"
        class="flex flex-col gap-8 max-w-237.25 mx-auto"
      >
        <NuxtLink
          v-for="entry in pageData.data"
          :key="entry.documentId"
          :to="localeRoute('/blog/' + entry.slug)"
          class="featured"
        >
          <PostComponent :image="entry.image.url || ''">
            <template #dateTime>
              <UiDateTime v-if="entry.date" :value="entry.date" />
            </template>
            <template #title>
              {{ entry.title }}
            </template>
            <template #description>
              {{ entry.description }}
            </template>
          </PostComponent>
        </NuxtLink>
      </div>
      <div v-else class="text-center py-2">{{ t('no-blog-posts') }}</div>
      <section>
        <InstallSection class="px-5 py-12.5" />
      </section>
    </div>
  </div>
</template>
